import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";

import MCInstructions from "../components/MCInstructions";
import EMentor from "../components/EMentor";
import MediaAttribution from "../components/MediaAttribution";
import { ImageAttribution } from "../components/ImageAttribution";

export default function PEEmentorObject(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  const supplementalInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case 0: {
        return pickInstructions("default");
      }
      case 1: {
        return pickInstructions("variation-2");
      }
      case 2: {
        return pickInstructions("variation-3");
      }
      case 3: {
        return pickInstructions("variation-0");
      }
      case 4: {
        return pickInstructions("variation-1");
      }
    }
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>
      <Typography className="text-16 font-bold p-16 pb-0">
        Page Instructions:
      </Typography>

      <MCInstructions
        ins={supplementalInstructions(ins, data.core.type_id)}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
        qIndex={0}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      {data.core.type_id === 0 && (
        <EMentor eMentor={data.core.eMentor} tl={tl} dir={dir} componentCommentsCount={componentCommentsCount} />
      )}

      {data.core.type_id === 1 && (
        <>
          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography className="text-16 font-bold m-0">Video:</Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <MediaAttribution
                    attribution={data.core.media}
                    timestamp={{
                      start_minute: data.core.start_minute,
                      end_minute: data.core.end_minute,
                      start_second: data.core.start_second,
                      end_second: data.core.end_second,
                    }}
                    tl={tl}
                    dir={dir}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </>
      )}

      {data.core.type_id === 2 && (
        <Paper elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography className="text-16 font-bold m-0">Audio:</Typography>
              <Divider className="my-16" />
            </Grid>
            <Grid item xs={12}>
              <Grid item xs={12}>
                <MediaAttribution
                  attribution={data.core.media}
                  timestamp={{
                    start_minute: data.core.start_minute,
                    end_minute: data.core.end_minute,
                    start_second: data.core.start_second,
                    end_second: data.core.end_second,
                  }}
                  tl={tl}
                  dir={dir}
                />
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      )}

      {(data.core.type_id === 3 || data.core.type_id === 4) && (
        <Paper elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography className="text-16 font-bold m-0">Image:</Typography>
              <Divider className="my-16" />
            </Grid>
            <Grid item xs={12}>
              <Grid item xs={12}>
                <ImageAttribution
                  attribution={data.core.media}
                  tl={tl}
                  dir={dir}
                />
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      )}

      {(data.core.type_id === 1 ||
        data.core.type_id === 2 ||
        data.core.type_id === 3) && (
        <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography className="text-14 font-bold m-0">
                    Context:
                  </Typography>
                  <Divider className="my-16" />
                </Grid>
                <Grid item xs={12}>
                  <Typography className={`${tl} m-0`} dir={dir}>
                    {data.core.context}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      )}

      {data.core.type_id === 1 && (
          data?.core?.cc && (
            <>
              <Typography className="text-16 font-bold p-16 px-32 pb-0">
                Closed Captions:
              </Typography>
              {data.core.cc.map((cc, index) => (
                <Paper
                  key={cc.id}
                  elevation={0}
                  variant="outlined"
                  square
                  className="p-16 pb-32 m-16"
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography className={`${tl} font-bold m-0`} dir={dir}>
                        {cc.tl_text}
                      </Typography>
                      <Divider className="my-16" />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={0.5}>
                        <Grid item xs={2}>
                          <Typography className="text-14 font-semibold m-0">
                            Time Stamp:
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <Typography className="text-14 m-0">
                            {cc.start_minute}:
                            {cc.start_second < 10
                              ? `0${cc.start_second}`
                              : cc.start_second}{" "}
                            - {cc.end_minute}:
                            {cc.end_second < 10
                              ? `0${cc.end_second}`
                              : cc.end_second}{" "}
                            (from trimmed media)
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              ))}
            </>
          )
      )}

      {data.core.type_id === 4 && (
        <>
          <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Prompt
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={`${tl} m-0`} dir={dir}>
                      {data.core.prompt}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Lures:
                </Typography>
                <Divider className="my-16" />
                <Grid container spacing={0}>
                  {data.core.lures.map((lure, index) => (
                    <Grid key={`lure-${lure.lure_text}-${index}`} item xs={12}>
                      {index > 0 && <Divider className="mt-2 mb-8" />}
                      <Grid container spacing={0} columns={24}>
                        <Grid item xs={4}>
                          {lure.is_correct ? (
                            <Grid container direction="row">
                              <Typography className="text-14 font-semibold m-0">
                                Correct
                              </Typography>
                              <BASESvgIcon
                                className="text-green-600 mx-2"
                                size={20}
                              >
                                heroicons-solid:check-circle
                              </BASESvgIcon>
                              <Typography className="text-14 font-semibold m-0">
                                Lure:
                              </Typography>
                            </Grid>
                          ) : (
                            <Grid container direction="row">
                              <Typography className="text-14 font-semibold m-0">
                                Incorrect
                              </Typography>
                              <BASESvgIcon
                                className="text-red-600 mx-2"
                                size={20}
                              >
                                heroicons-solid:x-circle
                              </BASESvgIcon>
                              <Typography className="text-14 font-semibold m-0">
                                Lure:
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                        <Grid item xs>
                          <Typography
                            className={`${tl} m-0 ${
                              index < data.core.lures.length - 1 && `mb-8`
                            }`}
                            dir={dir}
                          >
                            {lure.lure_text}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Correct Feedback:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{
                        __html: data.core.correct_feedback,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      First Incorrect Feedback:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{
                        __html: data.core.incorrect_feedback_1,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Second Incorrect Feedback:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{
                        __html: data.core.incorrect_feedback_2,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Final Incorrect Feedback:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      sx={{ margin: "0" }}
                      dangerouslySetInnerHTML={{
                        __html: data.core.incorrect_feedback_3,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </>
      )}
    </div>
  );
}